import { Component, OnInit, ElementRef } from '@angular/core';
import { FeedbackService } from 'src/app/modules/client/feedbacks/services/feedback.service';
import { ClientLoaderService } from 'src/app/shared/components/client-loader/client-loader.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env';
import { buildReturnOfTotvsData } from '@shared/utils/util';
import { GetStepsService } from '../registration-steps/pages/registration-steps-page/services/get-steps.service';

// import { ClientMainBarComponent } from 'src/app/layout/client/client-main-bar/client-main-bar.component'

@Component({
  selector: 'app-feedbacks',
  templateUrl: './feedbacks.component.html',
  styleUrls: ['./feedbacks.component.scss']
})
export class FeedbacksComponent implements OnInit {

  public customSettings: any = {};
  public feedbackData: any = new Array();
  public feedback;
  public visualIdentity;
  public feedbackLoaded = false;
  public loading;
  public env = environment;
  public background;
  constructor(
    // private feedbacksModel: FeedbacksModel,
    private feedbackService: FeedbackService,
    private loaderService: ClientLoaderService,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private getStepsService: GetStepsService,
  ) { }

  ngOnInit(): void {

    this.getStepsService.data.execute_stage_query = 1;

    this.loading = true;
    const id = this.route.snapshot.paramMap.get('id');
    this.feedbackService.getData(id,
      data => {
        this.feedback = data.feedback;
        this.visualIdentity = data.visual_identity;
        buildReturnOfTotvsData(this.feedback.query, this.feedback.content);
        if(this.feedback.background === null) {
          this.background = this.env.storage_path + this.visualIdentity.background;
        } else {
          this.background = this.env.storage_path + this.feedback.background;
        }
        this.loading = false;
        this.visualIdentity = data.visual_identity;
        this.feedbackLoaded = true;
      },
      error => {
        this.feedback = false;
        this.loading = false;
      }
    );
  }
}
